export const PHI = (1 + Math.sqrt(5)) / 2;
export const TAU = Math.PI * 2;
export const DEG2RAD_FACTOR = TAU / 360;
